/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

function updateRewardPoints(varPrice) {
    const pointsContainer = document.querySelector(".product__points");
    if (pointsContainer) {
      const originalText = pointsContainer?.textContent || "";

      const valuePattern = /\bX\b|\b\d+(\.\d+)?\b/;

      if (valuePattern.test(originalText)) {
        if (varPrice) {
          const variantPrice = varPrice / 100;
          const rewardPointsValue = variantPrice * 5;

          const newText = originalText.replace(valuePattern, rewardPointsValue);
          pointsContainer.textContent = newText;
        }
      }
    }
  }
 const priceElement = document.querySelector('block-price');
 const FirstPrice = priceElement?.dataset.price;
 updateRewardPoints(FirstPrice);

 function handleFreeShippingMessage() {
  const thresholdElement = document.querySelector(".max_value");
  const freeShippingLimit = parseFloat(thresholdElement?.textContent);

  const subtotalWrapper = document.querySelector("[data-subtotal] .visually-hidden");
  const displaySubtotal = subtotalWrapper?.innerText.trim(); // e.g. "$90.00"

  if (!displaySubtotal) return;

  // Extract numeric value for calculation (e.g., 90.00 from "$90.00")
  const numericSubtotal = parseFloat(displaySubtotal.replace(/[^\d.]/g, ""));

  const beforeMessage = document.querySelector(".before-message");
  const afterMessage = document.querySelector(".after-message");

  if (numericSubtotal >= freeShippingLimit) {
    beforeMessage?.classList.remove("hide");
    afterMessage?.classList.add("hide");
  } else {
    beforeMessage?.classList.add("hide");

    if (afterMessage) {
      const remainingAmount = (freeShippingLimit - numericSubtotal).toFixed(2);

      // Extract currency symbol from displaySubtotal (e.g. "$")
      const currencySymbol = displaySubtotal.replace(/[\d.,\s]/g, "");

      const formattedRemaining = ` ${currencySymbol}${remainingAmount}`; // Add leading space

      afterMessage.classList.remove("hide");

      // Replace 'X' or any currency+amount (e.g. "$90.00", "90", "€20") with formattedRemaining
      afterMessage.innerHTML = afterMessage.innerHTML.replace(
        /X|[$€£]?\s?\d+(?:[.,]\d{1,2})?/g,
        formattedRemaining
      );
    }
  }
}


setTimeout(() => {
  handleFreeShippingMessage();
}, 1000);

document.addEventListener("DOMContentLoaded", function () {
  const firstSection = document.querySelector(".main-content .shopify-section");
   const firstSection2 = document.querySelector(".main-content .shopify-policy__container");
  if (firstSection) {
    const header = firstSection.querySelector(".section-header__title");
    
    if (header) {
      document.body.classList.add("logo-overlay");
    }
  }
   if (firstSection2) {
    const header2 = firstSection2.querySelector(".shopify-policy__title");
    
    if (header2) {
      document.body.classList.add("logo-overlay");
    }
  }
});
